import React from 'react';
import { Mail, AlertTriangle, Forward } from 'lucide-react';
import { parseUtc } from './PendingLeaveTools';

const fmt = (iso) => (iso ? parseUtc(iso).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '');
const short = (t) => (t && t.length > 70 ? `${t.slice(0, 70)}…` : t);

const pronoun = (people) => {
  if (people.length !== 1) return 'their';
  const g = (people[0]?.gender || '').toLowerCase();
  return g === 'male' ? 'his' : g === 'female' ? 'her' : 'their';
};

const FailLine = ({ e }) => (
  <p className="text-xs text-red-600 flex items-center gap-1" title={e.error || ''}>
    <AlertTriangle className="h-3.5 w-3.5 shrink-0" /> Latest email to {e.to_name} ({e.to_email}) failed{e.error ? `: ${short(e.error)}` : ''}
  </p>
);

export const ApprovalRecipientNote = ({ leave, employee, allEmployees }) => {
  const byId = (id) => allEmployees.find((e) => e.id === id);
  const testId = `approval-note-${leave.id}`;
  if (leave.escalated_to_hr) {
    return (
      <p className="text-xs text-indigo-700 mt-1 flex items-center gap-1" data-testid={testId}>
        <Forward className="h-3.5 w-3.5" /> Forwarded to HR — awaiting HR decision{leave.escalation_note ? ` · ${leave.escalation_note}` : ''}
      </p>
    );
  }
  const emails = leave.approval_emails || [];
  if (emails.length) {
    const latest = {};
    emails.forEach((e) => { latest[e.to_email] = e; });
    const reached = Object.keys(latest).map((k) => emails.find((e) => e.to_email === k && e.status === 'sent')).filter(Boolean);
    const failed = Object.values(latest).filter((e) => e.status !== 'sent');
    const reminders = emails.filter((e) => e.kind === 'reminder' && e.status === 'sent');
    const people = reached.map((e) => byId(e.manager_id) || {});
    return (
      <div className="mt-1 space-y-0.5" data-testid={testId}>
        {reached.length > 0 && (
          <p className="text-xs text-sky-700 flex items-center gap-1">
            <Mail className="h-3.5 w-3.5 shrink-0" />
            Email sent to {reached.map((e) => `${e.to_name} (${e.to_email})`).join(', ')} on {fmt(reached[0].sent_at)} — awaiting {pronoun(people)} approval
            {reminders.length > 0 && ` · ${reminders.length} reminder${reminders.length > 1 ? 's' : ''}, last ${fmt(reminders[reminders.length - 1].sent_at)}`}
          </p>
        )}
        {failed.map((e) => <FailLine key={e.to_email} e={e} />)}
      </div>
    );
  }
  const managers = (employee?.reporting_manager_ids || []).map(byId).filter(Boolean);
  return (
    <p className="text-xs text-gray-500 mt-1 flex items-center gap-1" data-testid={testId}>
      <Mail className="h-3.5 w-3.5 shrink-0" />
      {managers.length
        ? `Awaiting ${pronoun(managers)} approval — ${managers.map((m) => `${m.name}${m.email ? ` (${m.email})` : ''}`).join(', ')} (reporting manager) · no email record for this older request`
        : 'No reporting manager on file — awaiting HR decision'}
    </p>
  );
};
